import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import WelcomeSplash from "@/components/WelcomeSplash";

/**
 * WelcomeGate — reads the AuthContext's `welcome` intent and renders the
 * full-screen splash overlay. Rendered once at the App root so it lives
 * independently of any route or guard.
 */
export default function WelcomeGate() {
  const navigate = useNavigate();
  const { welcome, clearWelcome } = useAuth();

  if (!welcome) return null;

  return (
    <WelcomeSplash
      text={welcome.text}
      onFinish={() => {
        const next = welcome.next;
        clearWelcome();
        if (next) navigate(next, { replace: true });
      }}
    />
  );
}
